module.exports = __webpack_public_path__ + "static/media/tech-coach-home-logo.d45950be.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/components/Header/resources/tech-coach-home-logo.svg
// module id = 3385
// module chunks = 0